export default {
    getIsLoading: state => {
        return state.isLoading;
    },
    getIsShow: state => {
        return state.isShow;
    },
    getIsPrint: state => {
        return state.isPrint;
    },
    getIsPreview: state => {
        return state.isPreview;
    },
    getIsFirstLoaded: state => {
        return state.isFirstLoaded;
    },
    getAppVersion: state => {
      return state.appVersion;
    },
    getMyApps: state => {
      return state.myApps;
    },
    getFavouriteMyApps: state => {
        return state.myApps.filter(myApp => myApp.favourite);
    },
    getDateRangeData: state => {
        return state.dateRangeData;
    },
    getDateTime: state => {
        return state.dateTime;
    },
    getOwnPage: state => {
        return state.ownPage;
    },
    getPages: state => {
        return state.pages;
    },
    getOwnPageData: state => {
        return state.ownPageData;
    },
    getCompetitorIds: state => {
        return state.competitorBenchmark.competitor_ids;
    },
    getCompetitors: state => {
        return state.competitorBenchmark.competitors;
    },
    getCompetitorAvg: state => {
        return state.competitorBenchmark.competitor_avg;
    }
}
